// Draft functions

export const makeTextToRaw = convertToRaw => state => {
    let notes = state.editorState.getCurrentContent();
    let raw = convertToRaw(notes);
    return JSON.stringify(raw);
}

export const makeRawToText = (convertFromRaw, EditorState) => (state, data) => {
    try { let parsed = JSON.parse(data);
    let newContent = convertFromRaw(parsed);
    const editorState = EditorState.push(
                state.editorState,
                newContent,
                "change-block-data"
              );
            
    return editorState
    } catch (error) {
                console.log("ERROR: " + error.message)
                return EditorState.createEmpty()
    }
}




// WEBPACK FOOTER //
// ./src/draftFunctions/draftFunctions.js